import Avatar from './Avatar';

export { Avatar };
